import BoxIcon from '@shared/components/BoxIcon';
import { ImperativeFormDialogRefType } from '@shared/components/UserFormDialog';
import { Stack } from '@mui/material';
import { useRef } from 'react';
import { ExistingStockItem } from '../entity';
import DeleteStockItemDialog from './stock-item-delete-dialog';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { StockItemFormDialog } from './stock-item-form-dialog';

export const StockItemActions = ({
  id,
  avgUnitPrice,
  itemName,
  stockId,
  totalPrice,
  quantity,
  lastPackageQuantity,
  threshold,
  unit,
  packageCount,
  itemType,
  retailPrice,
  brand,
}: ExistingStockItem) => {
  const editStockItemDialogRef = useRef<ImperativeFormDialogRefType>(null);
  const deleteStockItemDialogRef = useRef<ImperativeFormDialogRefType>(null);

  return (
    <>
      <Stack direction="row" spacing={{ xs: 0.75, sm: 1 }}>
        <BoxIcon
          onClick={() => editStockItemDialogRef.current?.open()}
          boxColor="secondary.light"
          size="medium"
          sx={{ borderRadius: '10px', boxShadow: '0 2px 5px rgba(19, 40, 71, 0.14)' }}
          icon={<EditOutlinedIcon fontSize="small" color="secondary" />}
        />
        <BoxIcon
          onClick={() => deleteStockItemDialogRef.current?.open()}
          size="medium"
          icon={<DeleteOutlineIcon fontSize="small" color="secondary" />}
          boxColor="primary.light"
          sx={{ borderRadius: '10px', boxShadow: '0 2px 5px rgba(19, 40, 71, 0.14)' }}
        />
      </Stack>
      <StockItemFormDialog
        dialogRef={editStockItemDialogRef}
        formUsagePurpose="stockItem"
        defaultValues={{
          id,
          itemName,
          stockId,
          totalPrice: Math.round(totalPrice),
          quantity: Math.round(quantity / packageCount),
          lastPackageQuantity,
          avgUnitPrice,
          threshold,
          unit,
          packageCount,
          itemType,
          retailPrice,
          brand,
        }}
      />
      <DeleteStockItemDialog dialogRef={deleteStockItemDialogRef} stockItemId={id} />
    </>
  );
};
